'use client'

import {
  FormProvider,
  UseFormProps,
  useForm,
  FieldValues,
  SubmitHandler,
} from 'react-hook-form'

export type FormProps<T extends FieldValues = FieldValues> = Omit<
  React.FormHTMLAttributes<HTMLFormElement>,
  'onSubmit'
> & {
  children?: React.ReactNode
  formProps?: UseFormProps<T>
  ref?: React.Ref<HTMLFormElement>
  onSubmit: SubmitHandler<T>
}

export function Form({
  children,
  formProps,
  ref,
  onSubmit,
  ...formAttrs
}: FormProps<any>) {
  const form = useForm({ mode: 'onChange', ...(formProps || {}) })

  return (
    <FormProvider {...form}>
      <form ref={ref} onSubmit={form.handleSubmit(onSubmit)} {...formAttrs}>
        {children}
      </form>
    </FormProvider>
  )
}

Form.displayName = 'Form'
